import { render, staticRenderFns } from "./ChangeTemplateModal.vue?vue&type=template&id=4f3c89f0&scoped=true&"
import script from "./ChangeTemplateModal.vue?vue&type=script&lang=js&"
export * from "./ChangeTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=4f3c89f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3c89f0",
  null
  
)

export default component.exports